import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import {TransparentImage} from "../constants";

@Pipe({
  name: 'imageCdnFile',
  pure: true
})
export class ImageCdnFilePipe implements PipeTransform {
  transform(fileStorageId: string): string {
    return fileStorageId ? `${environment.cdnUrl}${fileStorageId}` : TransparentImage;
  }
}
